import * as angular from "angular";
import {IController} from "angular";

export class TimeWindowCtrl implements IController {
  start: any;
  end: any;
  noToolTip: any;
}

angular
  .module('bringoz.admin.commons')
  .component('timeWindow', {
    bindings: {
      start: '<',
      end: '<',
      noToolTip: '<?'
    },
    template: require('./time-window.html').default,
    controller: TimeWindowCtrl
  });
